import axios from "axios";

import { SERVER_URL } from "../../../../config/env";

import authHeader from "../../../../2_ksbHub/utils/auth/auth-header";

const askomaFrontendService = {
  /**
   * =========================================================
   * ✅ GET LATEST MEASUREMENT
   * =========================================================
   */
  async getLatestMeasurement() {
    const res = await axios.get(SERVER_URL + "askomaapp/latest", {
      headers: authHeader(),
    });

    return res.data;
  },

  /**
   * =========================================================
   * ✅ GET MEASUREMENT HISTORY
   * =========================================================
   */
  async getMeasurementHistory(limit = null) {
    const res = await axios.get(SERVER_URL + "askomaapp/history", {
      headers: authHeader(),
      params: {
        limit,
      },
    });

    return res.data;
  },
};

export default askomaFrontendService;
